const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
const KPI_MANAGEMENT_PATH = "/api/kpi-management";

const buildPath = (path, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });
  return `${path}${query.toString() ? `?${query}` : ""}`;
};

const requestJson = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${path}`, options);
  const result = await response.json().catch(() => null);
  if (!response.ok || result?.success === false) {
    throw new Error(result?.message || `HTTP ${response.status}`);
  }
  return result;
};

const jsonOptions = (method, payload) => ({
  method,
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const fetchKpiBranches = ({ signal } = {}) =>
  requestJson(`${KPI_MANAGEMENT_PATH}/branches`, { signal });

export const fetchKpiSeasons = (branchId, { signal } = {}) =>
  requestJson(
    buildPath(`${KPI_MANAGEMENT_PATH}/seasons`, { branchId }),
    { signal }
  );

export const createKpiSeason = ({ TenMuaVu }) =>
  requestJson(
    `${KPI_MANAGEMENT_PATH}/seasons`,
    jsonOptions("POST", { TenMuaVu })
  );

export const updateKpiSeason = (seasonId, { TenMuaVu }) =>
  requestJson(
    `${KPI_MANAGEMENT_PATH}/seasons/${seasonId}`,
    jsonOptions("PUT", { TenMuaVu })
  );

export const saveKpiSeasonTarget = (seasonId, branchId, payload) =>
  requestJson(
    `${KPI_MANAGEMENT_PATH}/seasons/${seasonId}/targets/${branchId}`,
    jsonOptions("PUT", payload)
  );

export const deleteKpiSeason = (seasonId) =>
  requestJson(
    `${KPI_MANAGEMENT_PATH}/seasons/${seasonId}`,
    { method: "DELETE" }
  );

export const fetchKpiPhases = (seasonId, branchId, { signal } = {}) =>
  requestJson(
    buildPath(`${KPI_MANAGEMENT_PATH}/seasons/${seasonId}/phases`, {
      branchId,
    }),
    { signal }
  );

export const createKpiPhase = (payload) =>
  requestJson(
    `${KPI_MANAGEMENT_PATH}/phases`,
    jsonOptions("POST", payload)
  );

export const updateKpiPhase = (phaseId, payload) =>
  requestJson(
    `${KPI_MANAGEMENT_PATH}/phases/${phaseId}`,
    jsonOptions("PUT", payload)
  );

export const saveKpiPhaseTarget = (
  phaseId,
  branchId,
  { KPI, NgayBatDau, NgayKetThuc }
) =>
  requestJson(
    `${KPI_MANAGEMENT_PATH}/phases/${phaseId}/targets/${branchId}`,
    jsonOptions("PUT", { KPI, NgayBatDau, NgayKetThuc })
  );

export const deleteKpiPhase = (phaseId) =>
  requestJson(`${KPI_MANAGEMENT_PATH}/phases/${phaseId}`, {
    method: "DELETE",
  });

export const fetchPhaseDailyKpis = (
  phaseId,
  branchId,
  { signal } = {}
) =>
  requestJson(
    buildPath(`${KPI_MANAGEMENT_PATH}/phases/${phaseId}/days`, {
      branchId,
    }),
    { signal }
  );

export const savePhaseDailyKpis = (phaseId, branchId, payload) =>
  requestJson(
    buildPath(`${KPI_MANAGEMENT_PATH}/phases/${phaseId}/days`, {
      branchId,
    }),
    jsonOptions("PUT", payload)
  );
